<template lang="pug">
.v-managers-block.managers-block(v-if="block")
	.managers-block__container.container
		.managers-block__wrapper(v-if="isVisible")
			.managers-block__title(v-if="block.title") {{block.title}}
			.managers-block__photos
				.managers-block__photos-wrapper
					template(v-if="isSm")
						v-swiper-slider.managers-block__slider(:options="options"
								:navigation="navigation"
								@swiper="onSwiper")
							swiper-slide.managers-block__slide(v-if="block.items && block.items.length"
									v-for="(manager, managerIndex) in block.items"
									:key="managerIndex")
								.managers-block__manager(@click="playVideo(manager)")
									.managers-block__manager-card
										img.managers-block__manager-photo.managers-block__manager-photo--background(v-if="manager.photo"
												:src="manager.photo"
												alt="manager-photo"
												loading="lazy")
										img.managers-block__manager-photo(v-if="manager.photo"
												:src="manager.photo"
												alt="manager-photo"
												loading="lazy")
									.managers-block__photo-name-mobile(v-if="manager.name") {{manager.name}}
					template(v-else)
						button.managers-block__arrow.managers-block__arrow--prev(type="button" ref="man-prev" aria-label="Предыдущий слайд")
							v-svg-icon.managers-block__arrow-icon(icon="slide-left")
							v-svg-icon.managers-block__arrow-bg(icon="slide-left-bg")
						button.managers-block__arrow.managers-block__arrow--next(type="button" ref="man-next" aria-label="Следующий слайд")
							v-svg-icon.managers-block__arrow-icon(icon="slide-right")
							v-svg-icon.managers-block__arrow-bg(icon="slide-right-bg")
						v-swiper-slider.managers-block__slider(
								:options="options"
								:navigation="navigation"
								@swiper="onSwiper")
							swiper-slide.managers-block__slide(
									v-if="block.items && block.items.length"
									v-for="(manager, managerIndex) in block.items" :key="managerIndex")
								.managers-block__manager(@click="playVideo(manager, managerIndex)")
									.managers-block__manager-card
										img.managers-block__manager-photo(v-if="manager.photo"
												:src="manager.photo"
												alt="manager-photo"
												loading="lazy")
										.managers-block__manager-photo-gradient
										.managers-block__photo-footer
											v-svg-icon.managers-block__photo-icon(icon="triangle-gradient")
											.managers-block__photo-name(v-if="manager.name") {{manager.name}}
										.managers-block__photo-name-mobile(v-if="manager.name") {{manager.name}}
									//-template(v-if="activeSlide === managerIndex")
									//-	v-video.managers-block__manager-photo(
									//-			:src="manager.video.src"
									//-			:controls="videoOptions.controls"
									//-			:type="videoOptions.type"
									//-			:autoplay="videoOptions.autoplay"
									//-			:muted="videoOptions.muted"
									//-			:index="managerIndex"
									//-			:modalProp="videoOptions.modalProp"
									//-			modalClass="modal--mini")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller.js';
import breakpoints from '../scripts/breakpoints.js';
import {SwiperSlide} from 'swiper/vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin,
	],

	components: {
		SwiperSlide
	},

	data() {
		return {
			block: null,
			activeSlide: -1,
			isVisible: false,
			observer: null,
			videoOptions: {
				'autoplay': true,
				'muted': false,
				"controls": true,
			},
			options: {
				spaceBetween: 15,
				slidesPerView: 'auto',
				loop: false,
				breakpointsBase: 'container',
				breakpoints: {
					[breakpoints['xs-max']]: {
						spaceBetween: 20
					}
				}
			},
			allowTouchMove: true,
			pagination: {
				clickable: false
			},
			navigation: false
		};
	},

	beforeUnmount() {
		if (this.observer) {
			this.observer.disconnect();
		}
	},

	methods: {
		onObserver() {
			try {
				if (!this.$el) {
					console.warn('Элемент this.$el не определен.');
					this.isVisible = true;
					return;
				}
				if (typeof IntersectionObserver === 'undefined') {
					console.warn('IntersectionObserver не поддерживается.');
					this.isVisible = true;
					return;
				}
				this.observer = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							this.isVisible = true;
							this.observer.unobserve(entry.target);
						}
					});
				});
				this.observer.observe(this.$el);
			} catch (error) {
				console.error('Ошибка при создании IntersectionObserver:', error);
				this.isVisible = true;
			}
		},

		playVideo(data) {
			controller.openModal({
				className: 'modal--mini',
				component: {
					name: 'v-video',
					props: {...data.video, poster: null, ...this.videoOptions}
				}
			});
		},

		onSwiper() {
			this.navigation = {
				prevEl: this.$refs['man-prev'],
				nextEl: this.$refs['man-next']
			};
		},

		dataSet(data) {
			this.block = data;
			this.$nextTick(() => {
				this.onObserver();
			})
		}
	}
};
</script>